import { SnackbarProvider } from 'notistack'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import store from './store/configureStore'

import '@fontsource/vazir'
import './index.css'
import './i18n'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <SnackbarProvider
    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    autoHideDuration={3000}
    maxSnack={3}
    style={{ fontFamily: 'Vazir' }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </SnackbarProvider>,
)

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting

    if (waitingServiceWorker !== null) {
      waitingServiceWorker.addEventListener('statechange', (event: any) => {
        if (event.target.state === 'activated') {
          if (window.confirm('There is a new version of the app ready. Please reload to update.')) {
            window.location.reload()
          }
        }
      })
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' })
    }
  },
})
